import dayjs from "dayjs";
import {
  EventAvailabilityDetails,
  EventDetails,
  EventStatus,
  EventType,
} from "features/types";

export const formatEventDate = (
  event: EventDetails | EventAvailabilityDetails,
  format?: string
): string => {
  let eventStatus: EventStatus;

  if (event.hasOwnProperty("status")) {
    eventStatus = (event as EventDetails).status;
  } else {
    eventStatus = (event as EventAvailabilityDetails).eventStatus;
  }
  if (eventStatus !== "NORMAL") {
    return eventStatus;
  }

  let predefinedFormat = "";
  if (event.containsTime === false) {
    predefinedFormat = "ddd, MMM D";
  } else {
    predefinedFormat = "ddd, MMM D - h:mm a";
  }
  return dayjs(event.localDate)
    .tz(event.timezone)
    .format(format || predefinedFormat);
};

export const eventTypeDisplay = (eventType: EventType) => {
  const eventTypeDisplayName: { [key: string]: string } = {
    MINOR_HOCKEY: "HOCKEY",
    MBB: "BASKETBALL",
    WBB: "W BASKETBALL",
    WVB: "W VOLLEYBALL",
    WSOC: "W SOCCER",
    WGYM: "GYMNASTICS",
    WSB: "SOFTBALL",
    MINOR_BASKETBALL: "BASKETBALL",
    COLLEGE_BASEBALL: "BASEBALL",
    MSOC: "M SOCCER",
  };
  return eventTypeDisplayName[eventType] || eventType;
};
